module.exports = __webpack_public_path__ + "img/story-title.5ef6e4a2.png";